import { IndustryType } from "@labs/shared/types/IndustryType.ts";
import { EmissionsBySource } from "@labs/shared/types/EmissionsBySource.ts";

type IndustryTypeOption = {
  label: string;
  value: IndustryType;
  baselineEmissions: EmissionsBySource;
};

export const commercialOptions: IndustryTypeOption[] = [
  {
    label: "Banking/Financial Services",
    value: IndustryType.BankingFinancial,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 30,
      diesel: 5,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Education",
    value: IndustryType.Education,
    baselineEmissions: {
      electricity: 75,
      naturalGas: 20,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Entertainment/Public Assembly",
    value: IndustryType.EntertainmentPublicAssembly,
    baselineEmissions: {
      electricity: 65,
      naturalGas: 30,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Food Sales and Service",
    value: IndustryType.FoodSalesService,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 20,
      diesel: 10,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 10,
      other: 0,
    },
  },
  {
    label: "Healthcare",
    value: IndustryType.Healthcare,
    baselineEmissions: {
      electricity: 65,
      naturalGas: 30,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Lodging/Residential",
    value: IndustryType.LodgingResidential,
    baselineEmissions: {
      electricity: 65,
      naturalGas: 35,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Mixed Use",
    value: IndustryType.MixedUse,
    baselineEmissions: {
      electricity: 65,
      naturalGas: 30,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Office",
    value: IndustryType.Office,
    baselineEmissions: {
      electricity: 75,
      naturalGas: 20,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Public Services",
    value: IndustryType.PublicServices,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 30,
      diesel: 0,
      gasoline: 10,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Religious Worship",
    value: IndustryType.ReligiousWorship,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Retail",
    value: IndustryType.Retail,
    baselineEmissions: {
      electricity: 75,
      naturalGas: 20,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Warehouse",
    value: IndustryType.Warehouse,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 20,
      diesel: 10,
      gasoline: 10,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Other",
    value: IndustryType.CommercialOther,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 30,
      diesel: 0,
      gasoline: 10,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
];

export const industrialOptions: IndustryTypeOption[] = [
  {
    label: "Chemicals",
    value: IndustryType.Chemicals,
    baselineEmissions: {
      electricity: 20,
      naturalGas: 80,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Computer And Electronic Products",
    value: IndustryType.ComputerAndElectronicProducts,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Electrical Equipment Appliances And Components",
    value: IndustryType.ElectricalEquipmentAppliancesAndComponents,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Fabricated Metals",
    value: IndustryType.FabricatedMetals,
    baselineEmissions: {
      electricity: 40,
      naturalGas: 60,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Food And Beverage",
    value: IndustryType.FoodAndBeverage,
    baselineEmissions: {
      electricity: 45,
      naturalGas: 40,
      diesel: 5,
      gasoline: 5,
      propane: 0,
      fuelOil: 0,
      refrigerants: 5,
      other: 0,
    },
  },
  {
    label: "Machinery Manufacturing",
    value: IndustryType.MachineryManufacturing,
    baselineEmissions: {
      electricity: 50,
      naturalGas: 50,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Mixed Use",
    value: IndustryType.MixedUse,
    baselineEmissions: {
      electricity: 30,
      naturalGas: 70,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Nonmetallic Mineral Products",
    value: IndustryType.NonmetallicMineralProducts,
    baselineEmissions: {
      electricity: 30,
      naturalGas: 70,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Oil And Gas",
    value: IndustryType.PetroleumAndCoalProducts,
    baselineEmissions: {
      electricity: 20,
      naturalGas: 80,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Pulp And Paper",
    value: IndustryType.PulpAndPaper,
    baselineEmissions: {
      electricity: 50,
      naturalGas: 50,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Primary Metals",
    value: IndustryType.PrimaryMetals,
    baselineEmissions: {
      electricity: 30,
      naturalGas: 70,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Printing",
    value: IndustryType.Printing,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Textiles And Apparel",
    value: IndustryType.TextilesAndApparel,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Transportation Equipment",
    value: IndustryType.TransportationEquipment,
    baselineEmissions: {
      electricity: 50,
      naturalGas: 50,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Wood Products",
    value: IndustryType.WoodProducts,
    baselineEmissions: {
      electricity: 40,
      naturalGas: 50,
      diesel: 10,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Furniture",
    value: IndustryType.Furniture,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
  {
    label: "Miscellaneous Manufacturing",
    value: IndustryType.MiscellaneousManufacturing,
    baselineEmissions: {
      electricity: 60,
      naturalGas: 40,
      diesel: 0,
      gasoline: 0,
      propane: 0,
      fuelOil: 0,
      refrigerants: 0,
      other: 0,
    },
  },
];

export const industryTypeOptionsByGroup = [
  {
    label: "Commercial",
    options: commercialOptions,
  },
  {
    label: "Industrial",
    options: industrialOptions,
  },
];

export const commercialAndIndustrialOptions: IndustryTypeOption[] = [
  ...commercialOptions,
  ...industrialOptions,
];
